import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6444 1.58965C11.8664 1.47012 12.1336 1.47012 12.3556 1.58965L22.1056 6.83965C22.3485 6.97046 22.5 7.2241 22.5 7.50002C22.5 7.77593 22.3485 8.02957 22.1055 8.16037L19.1531 9.75L22.1055 11.3396C22.3485 11.4704 22.5 11.7241 22.5 12C22.5 12.2759 22.3485 12.5296 22.1055 12.6604L19.1531 14.25L22.1055 15.8396C22.3485 15.9704 22.5 16.2241 22.5 16.5C22.5 16.7759 22.3485 17.0295 22.1056 17.1604L12.3556 22.4104C12.1336 22.5299 11.8664 22.5299 11.6444 22.4104L1.89443 17.1604C1.65149 17.0295 1.49999 16.7759 1.5 16.5C1.50001 16.2241 1.65151 15.9704 1.89445 15.8396L4.84693 14.25L1.89445 12.6604C1.65151 12.5296 1.5 12.2759 1.5 12C1.5 11.7241 1.65151 11.4704 1.89445 11.3396L4.84693 9.75L1.89445 8.16037C1.65151 8.02957 1.50001 7.77593 1.5 7.50002C1.49999 7.2241 1.65149 6.97046 1.89443 6.83965L11.6444 1.58965ZM6.42897 10.6018L11.6444 13.4103C11.8664 13.5299 12.1336 13.5299 12.3556 13.4103L17.571 10.6018L20.1679 12L12 16.3982L3.83207 12L6.42897 10.6018ZM6.42897 15.1018L11.6444 17.9103C11.8664 18.0299 12.1336 18.0299 12.3556 17.9103L17.571 15.1018L20.168 16.5L12 20.8982L3.83201 16.5L6.42897 15.1018ZM3.83201 7.49997L12 11.8982L20.168 7.49997L12 3.10182L3.83201 7.49997Z"
        fill={colorValue}
      />
    </svg>
  );
};
